// @noflow
import moment from 'moment';
import type { Action, State } from './types';

const initialState: State = {
  billingEvents: [],
  vmEvents: [],
  limitAdTracking: false,
  auth: {
    lastVisitDate: undefined,
  },
  searchOpenMenu: undefined,
};

const reducer = (state: State = initialState, action: Action): State => {
  switch (action.type) {
    case 'VM_EVENT_ADD_TO_STORAGE': {
      const { event } = action;

      return {
        ...state,
        vmEvents: state.vmEvents.includes(event) ? state.vmEvents : [...state.vmEvents, event],
      };
    }

    case 'BILLING_EVENT_ADD_TO_STORAGE': {
      const { event } = action;

      return {
        ...state,
        billingEvents: state.billingEvents.includes(event)
          ? state.billingEvents
          : [...state.billingEvents, event],
      };
    }

    case 'VM_EVENT_REMOVE_FROM_STORAGE': {
      const { event } = action;
      const vmEvents = state.vmEvents.filter(item => item !== event);
      return {
        ...state,
        vmEvents,
      };
    }

    case 'BILLING_EVENT_REMOVE_FROM_STORAGE': {
      const { event } = action;
      const billingEvents = state.billingEvents.filter(item => item !== event);

      return {
        ...state,
        billingEvents,
      };
    }

    case 'GET_LIMIT_AD_TRACKING':
    case 'SET_LIMIT_AD_TRACKING': {
      const { limitAdTracking } = action;

      return {
        ...state,
        limitAdTracking,
      };
    }
    case 'QUANTUM_METRIC_STORE_LAST_VISIT_DATE': {
      return {
        ...state,
        auth: { lastVisitDate: moment().format('MMM Do YY') },
      };
    }

    case 'QUANTUM_METRIC_SET_SEARCH_OPEN_MENU': {
      return {
        ...state,
        searchOpenMenu: action?.menu,
      };
    }

    default:
      /* Following line assures switch exhaustiveness */
      (action.type: empty); /* eslint-disable-line */
      return state;
  }
};

export default reducer;
